import React from 'react';
import { myServices } from 'v5/services/services.connected.app';

/**
 * Hands a class component its browsing scope as the `appScope` prop
 * (`appScopeService.useSlugAppScope()`), for the v1 openers that need it
 * (`openModal`, `openContactSidebar`, …).
 */
export function withSlugAppScope(Component) {
  function WithSlugAppScope(props) {
    const appScope = myServices.appScopeService.useSlugAppScope();
    return <Component {...props} appScope={appScope} />;
  }
  WithSlugAppScope.displayName = `withSlugAppScope(${
    Component.displayName || Component.name
  })`;
  return WithSlugAppScope;
}
